export const MetaConstants = {
  Accordion: 'accordion',
  AccordionButton: 'accordion-button',
  AccordionItem: 'accordion-item',
  AccordionItemHeader: 'accordion-item-header',
  AccordionItemBody: 'accordion-item-body',
  ActionList: 'action-list',
  ActionListItem: 'action-list-item',
  ActionListSection: 'action-list-section',
  Alert: 'alert',
  Amount: 'amount',
  AutoComplete: 'autocomplete',
  Avatar: 'avatar',
  AvatarGroup: 'avatar-group',
  Badge: 'badge',
  BaseFilterChip: 'base-filter-chip',
  Box: 'box',
  BaseBox: 'base-box',
  BaseText: 'base-text',
  Button: 'button',
  ButtonGroup: 'button-group',
  Breadcrumb: 'breadcrumb',
  BreadcrumbItem: 'breadcrumb-item',
  BottomNav: 'bottomnav',
  BottomNavItem: 'bottomnav-item',
  Carousel: 'carousel',
  ChatInput: 'chat-input',
  ChatMessage: 'chat-message',
  ChatMessageThumbnailPreview: 'chat-message-thumbnail-preview',
  Checkbox: 'checkbox',
  CheckboxGroup: 'checkbox-group',
  CheckboxLabel: 'checkbox-label',
  CheckboxIconFade: 'checkbox-icon-fade',
  Chip: 'chip',
  ChipGroup: 'chip-group',
  ChipLabel: 'chip-label',
  Code: 'code',
  Component: 'blade-component',
  Counter: 'counter',
  CounterInput: 'counter-input',
  Display: 'display',
  Divider: 'divider',
  Drawer: 'drawer',
  EmptyState: 'empty-state',
  Dropdown: 'dropdown',
  DropdownOverlay: 'dropdown-overlay',
  DropdownFooter: 'dropdown-footer',
  DropdownHeader: 'dropdown-header',
  DatePicker: 'datepicker',
  Calendar: 'calendar',
  FileUpload: 'file-upload',
  FileUploadItem: 'file-upload-item',
  FileUploadLabel: 'file-upload-label',
  FilterChipGroup: 'filter-chip-group',
  Icon: 'icon',
  IconButton: 'icon-button',
  InfoGroup: 'info-group',
  InfoItem: 'info-item',
  InfoItemKey: 'info-item-key',
  InfoItemValue: 'info-item-value',
  InfoItemIcon: 'info-item-icon',
  Indicator: 'indicator',
  InputGroup: 'input-group',
  Link: 'link',
  List: 'list',
  ListItem: 'list-item',
  ListItemCode: 'list-item-code',
  ListItemLink: 'list-item-link',
  ListItemText: 'list-item-text',
  ListView: 'list-view',
  ListViewFilter: 'list-view-filter',
  OTPInput: 'otp-input',
  PasswordInput: 'password-input',
  SearchInput: 'search-input',
  TextArea: 'textarea',
  TextInput: 'textinput',
  PhoneNumberInput: 'phone-number-input',
  Toast: 'toast',
  ToastContainer: 'toast-container',
  TopNav: 'top-nav',
  TopNavBrand: 'top-nav-brand',
  TopNavContent: 'top-nav-content',
  TopNavActions: 'top-nav-actions',
  TabNav: 'tab-nav',
  TabNavItems: 'tab-nav-items',
  TabNavItem: 'tab-nav-item',
  TabNavItemLink: 'tab-nav-item-link',
  TabNavIndicator: 'tab-nav-indicator',
  ProgressBar: 'progress-bar',
  Radio: 'radio',
  RadioGroup: 'radio-group',
  RadioLabel: 'radio-label',
  SkipNav: 'skipnav',
  Spinner: 'spinner',
  SideNav: 'sidenav',
  SelectInput: 'select-input',
  Tag: 'tag',
  Tooltip: 'tooltip',
  TooltipInteractiveWrapper: 'tooltip-interactive-wrapper',
  Tabs: 'tabs',
  TabList: 'tab-list',
  TabItem: 'tab-item',
  TabPanel: 'tab-panel',
  TabIndicator: 'tab-indicator',
  Table: 'table',
  TableBody: 'table-body',
  TableRow: 'table-row',
  TableCell: 'table-cell',
  TableCellWrapper: 'table-cell-wrapper',
  TableSortButton: 'table-sort-button',
  TableHeader: 'table-header',
  TableHeaderRow: 'table-header-row',
  TableHeaderCell: 'table-header-cell',
  TableFooter: 'table-footer',
  TableFooterRow: 'table-footer-row',
  TableFooterCell: 'table-footer-cell',
  TableElement: 'table-element',
  TablePageSelectionButton: 'table-page-selection-button',
  TourPopover: 'tour-popover',
  TourMask: 'tour-mask',
  Popover: 'popover',
  PopoverInteractiveWrapper: 'popover-interactive-wrapper',
  BottomSheet: 'bottom-sheet',
  BottomSheetBody: 'bottom-sheet-body',
  BottomSheetHeader: 'bottom-sheet-header',
  BottomSheetFooter: 'bottom-sheet-footer',
  BottomSheetGrabHandle: 'bottomsheet-grab-handle',
  Card: 'card',
  CardBody: 'card-body',
  CardHeader: 'card-header',
  CardFooter: 'card-footer',
  Collapsible: 'collapsible',
  CollapsibleBody: 'collapsible-body',
  CollapsibleButton: 'collapsible-button',
  CollapsibleLink: 'collapsible-link',
  Menu: 'menu',
  MenuHeader: 'menu-header',
  MenuFooter: 'menu-footer',
  Modal: 'modal',
  ModalBody: 'modal-body',
  ModalHeader: 'modal-header',
  ModalFooter: 'modal-footer',
  ModalBackdrop: 'modal-backdrop',
  ModalScrollOverlay: 'modal-scroll-overlay',
  VisuallyHidden: 'visually-hidden',
  FormLabel: 'form-label',
  Switch: 'switch',
  SwitchLabel: 'switch-label',
  StyledBaseInput: 'styled-base-input',
  Skeleton: 'skeleton',
  StepGroup: 'step-group',
  StepItem: 'step-item',
  StepItemButton: 'step-item-button',
  PreviewWindow: 'preview-window',
  PreviewHeader: 'preview-header',
  PreviewBody: 'preview-body',
  PreviewFooter: 'preview-footer',
  Pagination: 'pagination',
  TimePicker: 'time-picker',
} as const;
